// Close the header call-to-action dropdown on outside click, link click, focus leaving it, or Escape
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-header-cta-menu][open]').forEach(function (menu) {
      if (menu !== except) menu.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    var menu = event.target.closest('[data-header-cta-menu]');
    if (menu && event.target.closest('.header-cta-menu__link')) {
      menu.removeAttribute('open');
      return;
    }
    closeAll(menu);
  });

  document.addEventListener('focusout', function (event) {
    var menu = event.target.closest('[data-header-cta-menu]');
    // Only when focus lands elsewhere on the page: Safari does not focus links on click, so a null relatedTarget must not close it
    if (menu && event.relatedTarget && !menu.contains(event.relatedTarget)) menu.removeAttribute('open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-header-cta-menu][open]');
    if (!open) return;
    open.removeAttribute('open');
    open.querySelector('summary').focus();
  });
})();
